(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("WujieReact", ["React"], factory);
	else if(typeof exports === 'object')
		exports["WujieReact"] = factory(require("react"));
	else
		root["WujieReact"] = factory(root["React"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__340__) {
return 